<!--  -->
<template>
    <div class='card_wrapper box box_v'   ref="left2">
        <div class="title">党员报到人数</div>
        <scroll  :style="{'height':height}">
            <div class="box_f1 box tr">
                <div 
                    v-for="(item,index) in list" :key="item.communityId"
                    :class="{'active':index==selectIndex}"
                    class="box box_between tr_item_wrapper" 
                    @click="selectParty(index)">
                    <div class="tr_item_title1">{{item.communityName}}</div>
                    <div class="tr_item_title2">{{item.partyMemberCount}}</div>
                </div>
            </div>

        </scroll>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import scroll from './scroll'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {scroll},
    data() {
    //这里存放数据
        return {
            list:[],
            height:'100%',
            selectIndex:-1
        };
    },
    props:{
        initStatus:{
            default:true,
            type:Boolean
        }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        initStatus(newVal){
            if(newVal) this.selectIndex=-1
        }
    },
    //方法集合
    methods: {
        getData(){
            this.$get(this.urlobj.xf_partyMemeber).then(res=>{
                this.list = res.rows
            })
        },
        selectParty(index){
            this.selectIndex = index
            if(this.list[index].partyMemberCount && this.list[index].partyList.length){
                this.$emit('selectParty',this.list[index])
            }else{
                this.$Message.info('暂无党支部')
            }
            
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$nextTick(()=>{
            this.height = this.$refs.left2.offsetHeight-68 + 'px'
            this.getData()
        })
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.card_wrapper{
    width: 100%;
    height:100%;
    background-image: url('../../../assets/images/monitorctxf/center.png');
    background-size: 100% 100%;
    //overflow-y: scroll;
    .title{
        margin:20px 0 20px 20px;
        color:#fff;
        font-size: 18px;
        font-weight: bold
    }
    .tr{
        flex-wrap: wrap
    }
    .tr_item_wrapper{
        box-shadow:0 0 5px #ffe400 inset; 
        margin:0 1% 10px 1%;
        height:40px;
        line-height: 40px;
        padding:0 10px;
        width:48%;
        box-sizing: border-box;
    }
    .tr_item_title1{
        font-size: 14px;
        color: #fff;
    }
    .tr_item_title2{
        font-size: 18px;
        font-style: italic;
        font-weight: bold;
        color: #B3DDFF;
        background: linear-gradient(0deg, #00F6FF 0%, #00FF90 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        padding-right:4px
    }
    .tr_item_title3{
        font-size: 14px;
        font-style: italic;
        color: #B3DDFF;
        background: linear-gradient(0deg, #00A8FF 10.205078125%, #4CECFF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .active{
        box-shadow:0 0 20px #ff0000 inset; 
    }
    
}
</style>